import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { AuthContext } from "@/contexts/AuthContext";

const useAuth = () => {
  return useContext(AuthContext);
};

export const useCurrentUser = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  if (!currentUser) {
    navigate("/auth/login", {
      state: {
        from: {
          pathname: location.pathname,
        },
      },
    });
    throw new Error("User not found");
  }

  return currentUser;
};

export default useAuth;
